import { PageInterface } from '../interfaces/page.interface';

export class PageModel implements PageInterface {
  /**
   * Number of elements per page
   */
  elementsPerPage = 10000;

  /**
   * Number of the page
   */
  pageIndex: number;

  /**
   * Create an instance of PageModel.
   *
   * @param page The page settings.
   */
  constructor(page: PageInterface) {
    this.elementsPerPage = page.elementsPerPage || 10;
    this.pageIndex = page.pageIndex || 0;
  }
}
